import { render, staticRenderFns } from "./footer-component.vue?vue&type=template&id=665f43a0&"
import script from "./footer-component.vue?vue&type=script&lang=js&"
export * from "./footer-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports